import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Total from "app/pages/.shared/PriceSummary/Total/Total";
import TotalNote from "app/pages/.shared/PriceSummary/TotalNote/TotalNote";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import appGlobalsContext from "app/AppGlobalsContext";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer.jsx";
import "./PriceSummary.scss";
import SavingsHighlightContainer from "app/pages/Booking/Quotation/PriceDetails/SavingsHighlightContainer";
import { calculateDiscountPercentage } from "app/utils/utils";

const QuotationPriceSummary = ({ hasChildren, total, savingsTotalAmount = 0 }) => {
	const { resolution } = useContext(appGlobalsContext);
	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;
	const publicPrice = savingsTotalAmount > 0 ? total + savingsTotalAmount : 0;

	const discountPercentage = calculateDiscountPercentage({
		publicPrice,
		savingsTotalAmount,
	});
	return (
		<>
			<div className="price-summary">
				{isMobile && (
					<>
						<QuotationPriceDetailContainer />
					</>
				)}

				{!isMobile && (
					<>
						<div className="price-summary__item">
							<Total
								total={total}
								discountPercentage={discountPercentage}
								taxesAndFeesIncluded
							/>
						</div>
						{publicPrice > 0 && (
							<div className="price-summary__reference">
								<FormattedMessage
									id="general.instead.of.price.with.amount"
									values={{
										price: <AmountContainer amount={publicPrice} />,
									}}
								/>
							</div>
						)}
						<div className="price-summary__item price-summary__item--savings">
							<SavingsHighlightContainer
								messageKey="general.savings.realized.with.amount"
								trackEvent="booking_click_savings_realized"
								description={
									<div>
										<div className="savings-highlight__description-title">
											<FormattedMessage id="savings.tooltip.title" />
										</div>
										<ul className="savings-highlight__list">
											<li>
												<FormattedMessage id="savings.tooltip.line1" />
											</li>
											<li>
												<FormattedMessage id="savings.tooltip.line2" />
											</li>
										</ul>
									</div>
								}
							/>
						</div>

						<TotalNote showChildrenNote={hasChildren} />
					</>
				)}
			</div>
		</>
	);
};

QuotationPriceSummary.propTypes = {
	total: PropTypes.number,
	savingsTotalAmount: PropTypes.number,
	hasChildren: PropTypes.bool,
};

export default memo(QuotationPriceSummary);
